import React, { useState, useEffect } from "react";
import { FaEye, FaEyeSlash, FaInfoCircle } from "react-icons/fa";
import "./../assets/scss/login.scss";
import Footerweb from "../components/layout/footer/Footerweb";
import Headerweb from "../components/layout/header/Headerweb";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { showToast } from "../utils/utils";
import publicAxios from "../utils/publicAxios";
import {
  changeUserPass,
  header_web,
  invalidEmailOrToken,
  ownerTab,
  passwordtext,
  referencePromoCode,
  reset_password,
  tooltips
} from "../locales/en";
import { getConfirmForgetPasswordURL } from "../utils/constants/apiEndPoints";
import { LOGIN, SIGN_UP } from "../route/paths";

const ResetPassword = () => {
  const [email, setEmail] = useState("");
  const [token, setToken] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [isValid, setIsValid] = useState(false);

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const emailParams = queryParams.get("email");
  const tokenParams = queryParams.get("token");
  const decodedEmail = emailParams
    ? decodeURIComponent(emailParams).replace(/ /g, "+")
    : "";
  useEffect(() => {
    // Validate the presence of email and token
    if (emailParams && tokenParams) {
      setIsValid(true);
      setEmail(decodedEmail);
      setToken(tokenParams);
    } else {
      setIsValid(false);
    }
  }, [emailParams, tokenParams, decodedEmail]);

  const initialErrors = {
    password: {},
    confirmPassword: {}
  };
  const [errors, setErrors] = useState(initialErrors);

  const navigate = useNavigate();

  const handlePasswordChange = (e) => {
    const newErrors = { ...errors };
    setPassword(e.target.value);
    newErrors.password = [];
    setErrors(newErrors);
  };

  const handleConfirmPasswordChange = (e) => {
    const newErrors = { ...errors };
    setConfirmPassword(e.target.value);
    newErrors.confirmPassword = [];
    setErrors(newErrors);
  };

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let isValid = true;

    const newErrors = { ...errors };

    if (!password) {
      newErrors.password = ["Please enter the password"];
      isValid = false;
    }

    if (password !== confirmPassword) {
      newErrors.confirmPassword = ["Password do not match"];
      isValid = false;
    }
    setErrors(newErrors);
    if (isValid) {
      const userData = {
        email: email,
        password: password,
        confirmPassword: confirmPassword,
        token: token
      };
      try {
        const response = await publicAxios.post(
          getConfirmForgetPasswordURL,
          userData
        );
        if (response.status === 200) {
          showToast(response.data.message, "success");
          navigate(LOGIN);
          setPassword("");
          setConfirmPassword("");
          setErrors(initialErrors);
        }
      } catch (error) {
        if (error.response.status === 400) {
          const apiErrors = error.response.data.errors[0];
          setErrors(apiErrors);
          setPassword("");
          setConfirmPassword("");
        } else {
          const errorMessage = error.response.data.message;
          setErrorMessage(errorMessage);
          setErrors(initialErrors);
        }
      }
    }
  };

  return (
    <>
      <Headerweb />

      <main>
        <div className="signup-hero-section">
          <div className="container-wrap">
            <div className="hero-content">
              <h1>
                <strong>{tooltips.reset}</strong> {changeUserPass.password}
              </h1>
            </div>
          </div>
        </div>

        {!isValid ? (
          <div className="sign-up-wrap">
            <div className="container-wrap">
              <div className="col-row">
                <div className="center-wrap">
                  <div className="sign-up-form reset-password-form">
                    <div className="fundtap-heading">
                      <div className="title-left">
                        <p>{invalidEmailOrToken.text}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="sign-up-wrap">
            <div className="container-wrap">
              <div className="col-row">
                <div className="center-wrap">
                  <div className="sign-up-form reset-password-form">
                    <div className="fundtap-heading">
                      <div className="title-left">
                        <p> {referencePromoCode.text50}</p>
                      </div>
                      <div className="signup-btn-right">
                        {reset_password.or}
                        <Link to={SIGN_UP} className="btn-primary">
                          {header_web.link7}
                        </Link>
                      </div>
                    </div>
                    <form id="reset_form">
                      <div className="input-row">
                        <div className="input-group">
                          <input
                            type="email"
                            placeholder="Email Address"
                            value={email}
                            name="email"
                            id="email"
                            autoComplete="false"
                            disabled
                          />
                        </div>
                      </div>
                      <div className="input-row">
                        <div className="input-group">
                          <label htmlFor="password">
                            {changeUserPass.password}
                          </label>
                          <div className="password-show">
                            <input
                              type={showPassword ? "text" : "password"}
                              onChange={handlePasswordChange}
                              value={password}
                              name="password"
                              id="password"
                              placeholder="********"
                            />
                            <button
                              type="button"
                              className="password-icon"
                              onClick={handleClickShowPassword}
                            >
                              {showPassword ? <FaEyeSlash /> : <FaEye />}
                            </button>
                          </div>

                          {Array.isArray(errors.password) &&
                            errors.password.map((msg, index) => (
                              <p key={index} className="error-message mb-0">
                                <small>
                                  <FaInfoCircle /> {msg}
                                </small>
                              </p>
                            ))}
                        </div>
                      </div>
                      <div className="input-row">
                        <div className="input-group">
                          <label htmlFor="confirmPassword">
                            {passwordtext.confPass}
                          </label>
                          <div className="password-show">
                            <input
                              type="password"
                              onChange={handleConfirmPasswordChange}
                              value={confirmPassword}
                              name="confirmPassword"
                              id="confirmPassword"
                              placeholder="********"
                            />

                            {Array.isArray(errors.confirmPassword) &&
                              errors.confirmPassword.map((msg, index) => (
                                <p key={index} className="error-message mb-0">
                                  <small>
                                    <FaInfoCircle /> {msg}
                                  </small>
                                </p>
                              ))}
                          </div>
                        </div>
                      </div>
                      <div className="input-row">
                        <div className="input-group">
                          <button
                            type="button"
                            className="btn-primary"
                            onClick={handleSubmit}
                          >
                            {ownerTab.ownerInfo.resetPass}
                          </button>
                        </div>
                      </div>
                      {errorMessage && (
                        <p className="error-message">
                          <small>{errorMessage}</small>
                        </p>
                      )}
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </main>

      <Footerweb />
    </>
  );
};

export default ResetPassword;
